import { render, staticRenderFns } from "./medkitlogMedUsed.vue?vue&type=template&id=2514bfdd"
import script from "./medkitlogMedUsed.vue?vue&type=script&lang=js"
export * from "./medkitlogMedUsed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports